import React from 'react';
import DndLists from './DndLists';
import DndListStore from '../../stores/DndListStore'
import {DragDropContext} from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

@DragDropContext(HTML5Backend)
export default class App extends React.Component {
  constructor(props) {
    super(props);

    const store = DndListStore;
  }
  render() {
    return (
      <div>
        <DndLists items={DndListStore.dndLists} />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/DnD/App.js